import { useMutation } from '@apollo/client';
import { LikeMessageDocument } from './LikeChatMessage.gql';
export function useLikeChatMessage() {
    const [mutate, state] = useMutation(LikeMessageDocument);
    const handler = (input) => mutate({ variables: { input } });
    return [handler, state];
}
